import { pushFbqEvent } from '@/utils/fbqTrack'
import { useFbRuntimeConfig, waitForFbConfig } from '@/composables/fbq/useFbRuntimeConfig'

const lastReportTimes = new Map<string, number>()
const DEDUP_WINDOW_MS = 5000

export function useFbqAddToCart() {
  const { isEventEnabled } = useFbRuntimeConfig()

  async function reportAddToCart(
    productId: string | number,
    productName: string,
    price: string | number,
  ) {
    const key = String(productId)
    const now = Date.now()
    if (lastReportTimes.has(key) && now - lastReportTimes.get(key)! < DEDUP_WINDOW_MS)
      return
    lastReportTimes.set(key, now)

    await waitForFbConfig()
    if (!isEventEnabled('ADD_TO_CART'))
      return

    pushFbqEvent('AddToCart', {
      product_id: key,
      product_name: productName,
      price_usd: String(price),
      currency: 'USD',
    }, 'fb_add_to_cart')
  }

  return { reportAddToCart }
}
